import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';


const Dashboard = () => {
    const {isAuthenticated, user} = useAuth0();
   
  
    
    return (
      isAuthenticated &&(
        <div class = "dashboard">
            




<div class = "container">
        <h2 class="head-title" id = "dashboard-main"><span>EmpowHer Dashboard</span></h2>
        <h2 class = "head-title" id = "welcome">Welcome Back!</h2>
        <p class = "center task-header">Pending Tasks</p>
        <p>The EmpowHer project submission includes three components: Short Essays, Video, and Design History File. You can work on these components in any order. You will also need to complete a team information form for demographic purposes.</p>
        <p>When you have completed your project, please submit it via the button labeled "Submit".</p>
        <p>All submission materials, including the team information form, must be submitted by <span id = "submit-time">Friday, June 11th, 2021 at 11:59 PM Eastern Time</span> (please note the time zone). If you have any questions or encounter any problems, please message us in Slack or email us at info@metrohacks.org</p>
        
          <div class = "right-padding">
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/team-information.html"> <img class = "timeline-img" src = "empowher-assets/img/list.svg"/> </a>
          <a target = "blank"  href = "https://metrohacks-empowher-participant-portal.github.io/team-information.html">Team Information Form</a>
            
          </div>


          
          
          <div class = "right-padding">
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/video-submission.html"> <img class = "timeline-img" src = "empowher-assets/img/list.svg"/> </a>
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/video-submission.html">Video</a>
            
          </div>
 
          
          <div class = "right-padding">
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/short-essays"> <img class = "timeline-img" src = "empowher-assets/img/list.svg"/> </a>
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/short-essays">Short Essays</a>
            
          </div>
          
          
          
          
          <div class = "right-padding">
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/design-history"> <img class = "timeline-img" src = "empowher-assets/img/list.svg"/> </a>
          <a target = "blank" href = "https://metrohacks-empowher-participant-portal.github.io/design-history">Design History File</a>
            
          </div>
        
  </div>

  

  
</div>


        
        
      )
    );
  };
  
  export default Dashboard;